import { render, staticRenderFns } from "./paperListComp.vue?vue&type=template&id=000e6a63&scoped=true"
import script from "./paperListComp.vue?vue&type=script&lang=js"
export * from "./paperListComp.vue?vue&type=script&lang=js"
import style0 from "./paperListComp.vue?vue&type=style&index=0&id=000e6a63&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000e6a63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000e6a63')) {
      api.createRecord('000e6a63', component.options)
    } else {
      api.reload('000e6a63', component.options)
    }
    module.hot.accept("./paperListComp.vue?vue&type=template&id=000e6a63&scoped=true", function () {
      api.rerender('000e6a63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearch/comps/paperListComp.vue"
export default component.exports